document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => header.classList.toggle('scrolled', window.scrollY > 20));
  }
  const hamburger = document.querySelector('.hamburger');
  const mobileMenu = document.getElementById('mobileMenu');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', () => {
      mobileMenu.classList.toggle('open');
      document.body.style.overflow = mobileMenu.classList.contains('open') ? 'hidden' : '';
    });
    mobileMenu.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {
      mobileMenu.classList.remove('open');
      document.body.style.overflow = '';
    }));
  }
  document.querySelectorAll('.gallery-thumb').forEach(thumb => {
    thumb.addEventListener('click', function() {
      const gallery = this.closest('.product-gallery');
      const mainImg = gallery.querySelector('.gallery-main img');
      if (mainImg) mainImg.src = this.querySelector('img').src;
      gallery.querySelectorAll('.gallery-thumb').forEach(t => t.classList.remove('active'));
      this.classList.add('active');
    });
  });
  document.querySelectorAll('.accordion-toggle').forEach(btn => {
    btn.addEventListener('click', function() {
      const item = this.closest('.accordion-item');
      const isOpen = item.classList.contains('open');
      item.closest('.accordion').querySelectorAll('.accordion-item').forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });
  document.querySelectorAll('.atc-btn').forEach(btn => {
    btn.addEventListener('click', function() {
      if (this.type === 'submit') return;
      const orig = this.innerHTML;
      this.innerHTML = '✓ Ajouté !';
      setTimeout(() => this.innerHTML = orig, 2200);
    });
  });
});
